import { lazy } from 'react'

// Admin Components - User Management
export const UserProfile = lazy(() => import('../Admin/Pages/User/UserProfile'))
export const UserIndex = lazy(
    () => import('../../feature/admin/Users/index/UserIndex')
)
export const UserActivityIndex = lazy(
    () => import('../../feature/admin/Users/index/UserActivityIndex')
)

// Admin Components - Reports & Files
export const ReportsOverview = lazy(
    () => import('../Admin/Pages/Reports/ReportsOverview')
)
export const Files = lazy(() => import('../Admin/Pages/Files/Files'))

// Admin Components - Security & Permissions
export const SecurityIndex = lazy(
    () => import('../Admin/Pages/Security/SecurityIndex')
)
export const RolesIndex = lazy(
    () => import('../../feature/admin/Roles/RolesIndex')
)
export const RoleDetail = lazy(
    () => import('../../feature/admin/Roles/RoleDetail')
)
export const PermissionIndex = lazy(
    () => import('../../feature/admin/Permissions/index/PermissionIndex')
)

// Admin Components - Environment & Configuration
export const EnvironmentEdit = lazy(
    () => import('@/feature/admin/Environment/components/EnvironmentEdit')
)
export const ModulesIndex = lazy(
    () => import('../Admin/Pages/Modules/ModulesIndex')
)
export const Languages = lazy(
    () => import('../Admin/Pages/Languages/Languages')
)
export const Layout = lazy(() => import('../Admin/Pages/Layout/Layout'))

// Admin Components - Dossiers
export const DefDossierIndex = lazy(
    () => import('@/feature/DefDossier/Index/DefDossierIndex')
)
export const DefDossierEdit = lazy(
    () => import('../Admin/Pages/DefDossier/DefDossierEdit')
)
export const DefDossierConditions = lazy(
    () => import('../Admin/Pages/DefDossier/DefDossierConditions')
)
export const ErdDiagram = lazy(
    () => import('../Admin/Pages/DefDossier/ErdDiagram')
)
export const FieldEditor = lazy(
    () => import('../Admin/Pages/DefDossier/FieldEditor')
)
export const DossierFlow = lazy(
    () => import('../Admin/Pages/DefDossier/DossierFlow/DossierFlowIndex')
)

// Admin Components - Content Dossiers
export const DetailContentDossier = lazy(
    () => import('../../feature/ContentDossier/Detail/ContentDossier')
)
export const CreateContentDossier = lazy(
    () => import('../../feature/ContentDossier/Create/CreateContentDossier')
)

// Admin Components - Blocks & Events
export const BlocksIndex = lazy(
    () => import('../../feature/admin/Blocks/Index/Blocks')
)
export const BlockDetail = lazy(
    () => import('../Admin/Pages/Blocks/BlockDetail')
)
export const EventsIndex = lazy(
    () => import('../../feature/admin/Events/Index/Events')
)

// Admin Components - Templates & Documents
export const TemplateOverview = lazy(
    () => import('../Admin/Pages/Templates/TemplateOverview')
)
export const TemplateForm = lazy(
    () => import('../Admin/Pages/Templates/TemplateForm')
)
export const KedocxIndex = lazy(
    () => import('../Admin/Pages/Kedocx/KedocxIndex')
)
export const KedocxEditor = lazy(
    () => import('../Admin/Pages/Kedocx/KedocxEditor')
)

// Admin Components - Query Builder
export const QueryBuilderIndex = lazy(
    () => import('../../feature/admin/QueryBuilder/QueryBuilderIndex')
)
export const QueryBuilderEditor = lazy(
    () => import('../../feature/admin/QueryBuilder/QueryBuilderEditor')
)

// Admin Components - Context Filters
export const ContextFilterIndex = lazy(
    () => import('../Admin/Pages/ContextFilter/ContextFilterIndex')
)
export const ContextFilterDetail = lazy(
    () => import('../Admin/Pages/ContextFilter/ContextFilterDetail')
)

// Admin Components - Data Structures
export const DataStructureIndex = lazy(
    () => import('../Admin/Pages/DataStructures/DataStructuresIndex')
)
export const DataStructureEdit = lazy(
    () => import('../Admin/Pages/DataStructures/DataStructuresEdit')
)

// Admin Components - Messages & Queue
export const MessageOverview = lazy(() => import('../../feature/user/messages'))
export const MessageQueueIndex = lazy(
    () => import('../Admin/Pages/MessageQueue/MessageQueueIndex')
)

// Admin Components - Webhooks & Logs
export const WebhookIndex = lazy(
    () => import('../../feature/admin/webhooks/index/WebhooksIndex')
)
export const LogIndex = lazy(() => import('../../feature/admin/Log/LogIndex'))

// Feature Modules
export const ToewijzingIndex = lazy(
    () => import('@/feature/module/JwWmo/ToewijzingIndex')
)

// Subscription & Orders
export const MySubscriptions = lazy(
    () => import('../Pages/MySubscriptions/MySubscriptions')
)
export const MyOrder = lazy(() => import('../Pages/MySubscriptions/MyOrder'))

// Utilities
export const ImportData = lazy(() => import('../Pages/Import/ImportData'))
export const Upgrade = lazy(() => import('../Pages/Upgrade/Upgrade'))

// Page Components
export const Colleagues = lazy(() => import('../Pages/Colleagues'))
